// @ts-nocheck

import palette from '../palette';

export const MatchFilterItem = {
  button: {
    background: {
      default: palette.black,
      fill: palette.white,
    },
    border: {
      fill: palette.white,
      default: palette.neutralgrey800,
    },
  },
  count: {
    default: palette.neutralgrey300,
    fill: palette.black,
  },
  label: {
    fill: palette.black,
    default: palette.white,
  },
};
